import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { REG_EXP } from '../utilities/reg-exp';

@Directive({
  selector: '[appNumberOnly]',
  standalone: true,
})
export class NumberOnlyDirective {
  private el = inject(ElementRef);

  private regex = REG_EXP.ONLY_NUMBER;
  private specialKeys: string[] = [
    'Backspace',
    'Tab',
    'Delete',
    'Enter',
    'Escape',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste',
  ];

  inputElement: HTMLInputElement = this.el.nativeElement;

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedInput = event.clipboardData?.getData('text/plain').replace(this.regex, ''); // get a digit-only string

    if (pastedInput) {
      if (isNaN(Number(pastedInput))) {
        event.preventDefault();
      } else {
        document.execCommand('insertText', false, pastedInput);
      }
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    const textData = event.dataTransfer?.getData('text').replace(this.regex, '');
    this.el.nativeElement.focus();

    if (textData) {
      if (isNaN(Number(textData))) {
        event.preventDefault();
      } else {
        document.execCommand('insertText', false, textData);
      }
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (
      // Allow: Delete, Backspace, Tab, Escape, Enter, etc
      this.specialKeys.indexOf(event.key) > -1 ||
      (event.key === 'a' && event.ctrlKey === true) || // Allow: Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) || // Allow: Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) || // Allow: Ctrl+V
      (event.key === 'x' && event.ctrlKey === true) || // Allow: Ctrl+X
      (event.key === 'a' && event.metaKey === true) || // Cmd+A (Mac)
      (event.key === 'c' && event.metaKey === true) || // Cmd+C (Mac)
      (event.key === 'v' && event.metaKey === true) || // Cmd+V (Mac)
      (event.key === 'x' && event.metaKey === true) // Cmd+X (Mac)
    ) {
      return; // let it happen, don't do anything
    }
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    if (event.key === ' ' || isNaN(Number(event.key))) {
      event.preventDefault();
    }
    // const current: string = this.el.nativeElement.value;
    // const next: string = current.concat(event.key);

    // if (next.includes('.')) {
    //   if (this.text == next) {
    //     event.preventDefault();
    //   }
    //   this.text = next;
    // }
    // if (next && !String(next).match(this.regex)) {
    //   event.preventDefault();
    // }
  }
}
